module.exports = __webpack_public_path__ + "img/whatsapp_logo.5c91df4c.webp";